import Vue from 'vue';

// Keeping the invoiceChanged subscription open costs an ActionCable channel per
// open tab, and every Log::InvoiceMail write on the server broadcasts to all of
// them. So the invoice page only listens while a delivery is actually in
// flight, and this module decides when that is.
//
// The window slides: deliveries are asynchronous and an EHF invoice travels
// through fakturaBank and the recipient's access point, so a fixed timeout
// after the send would regularly cut off before the final status arrives.
// Every update that comes in pushes the deadline out again.
const IDLE_MS = 5 * 60 * 1000;
// ...but an invoice that gets stuck must not hold the subscription open
// forever, so there is a hard ceiling regardless of activity.
const MAX_MS = 30 * 60 * 1000;

// Only one invoice is on screen at a time, so a single slot is enough.
const state = Vue.observable({ invoiceId: null as string | null });

// window.setTimeout, not the bare global: @types/node otherwise types these
// as NodeJS.Timeout, which clearTimeout will not take alongside undefined.
let idleTimer: number | undefined;
let maxTimer: number | undefined;

export function stopWatching() {
  clearTimeout(idleTimer);
  clearTimeout(maxTimer);
  idleTimer = undefined;
  maxTimer = undefined;
  state.invoiceId = null;
}

function resetIdleTimer() {
  clearTimeout(idleTimer);
  idleTimer = window.setTimeout(stopWatching, IDLE_MS);
}

// Call when a delivery has been asked for: the invoice was just created, or the
// user pressed one of the send buttons. The id is nullable because that is how
// the generated invoice types declare it; there is nothing to watch without one.
export function watchInvoice(invoiceId: string | null) {
  if (!invoiceId) return;

  if (state.invoiceId !== invoiceId) {
    stopWatching();
    state.invoiceId = invoiceId;
    maxTimer = window.setTimeout(stopWatching, MAX_MS);
  }

  resetIdleTimer();
}

// Call when something actually changed, to slide the window forward.
export function keepWatching(invoiceId: string) {
  if (state.invoiceId !== invoiceId) return;

  resetIdleTimer();
}

// Reactive — read it from a computed to gate the subscription.
export function watchedInvoiceId() {
  return state.invoiceId;
}
